<template>
  <tr @click="toggleIndividualContact()">
    <td>{{ rowNumber }}</td>
    <td>{{ formatDate(contact.sentDate) }}</td>
    <td>{{ formatDate(contact.receiver.joinedDate) }}</td>
    <td>{{ contact.receiver.last_name }} {{ contact.receiver.name }}</td>
    <td>{{ contact.jobDetail }}</td>
    <td>
      <span class="user-response" v-if="userResponse">{{ userResponse }}</span>
    </td>
    <td>
      <span class="status-badge" :style="{ backgroundColor: getStatusColor(contact.receiver.status), color: getStatusTextColor(contact.receiver.status) }">{{ contact.receiver.status }}</span>
    </td>
    <td>{{ contact.sender || '' }}</td>
    <td style="text-align: center !important;">
      <div class="interview-container" @click.stop>
        <Interview
          :interview="contact.receiver.isInterview"
          @click.native="toggleInterview(contact.receiver)"
          :toggledisabledInt="loading"
        />
      </div>
    </td>
    <IndividualContactModal
      v-if="showIndividualContact"
      :applicantIndex="index"
      :applicant_id="contact.receiver._id"
      :showIndividualContact="showIndividualContact"
      contactListType="sent"
      @cancel="toggleIndividualContact"
    />
  </tr>
</template>

<script>
import moment from 'moment';
import IndividualContactModal from '../IndividualContactModal.vue';
import Interview from '@/components/dashboard/applicants/Interview.vue';
import Api from '../../../../config/api';
import ApiService from '../../../../service/apiService';
import { mapMutations } from 'vuex';

export default {
  name: 'ReceivedContactRow',
  props: ['sentContact', 'index', 'rowNumber'],
  components: { IndividualContactModal, Interview },
  data() {
    return {
      contact: this.sentContact,
      loading: false,
      showIndividualContact: false,
    };
  },
  computed: {
    userResponse() {
      if (this.contact.contactDetail == 'その他通知') {
        return '通知のみ';
      }
      return this.contact.user_response;
    },
  },
  methods: {
    ...mapMutations(['mutateSentListAfterInterview']),
    toggleIndividualContact() {
      this.showIndividualContact = !this.showIndividualContact;
    },
    formatDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    getStatusColor(status) {
      const colorMap = {
        '未判定': '#DD2A29',
        'スカウト対象': '#006C6B',
        'スカウト対象外': '#AB8271',
        '確認中': '#FFEA00',
        'スカウト済': '#71B566',
        '返信有': '#E08282',
        '応募有': '#14B8A6',
        'システム取込み済': '#787878',
        '中長期対応': '#8F5AA5',
        'その他': '#535252',
      };
      return colorMap[status] || '#6C757D';
    },
    getStatusTextColor(status) {
      // Yellow status needs dark text, others use white
      return status === '確認中' ? '#000' : '#fff';
    },
    openIndividualContact(applicant) {
      let routeUrl = this.$router.resolve({
        path: `/applicant/${applicant._id}/contact`,
      });
      // Open in a new tab
      window.open(routeUrl.href, '_blank');
    },
    toggleInterview(applicant) {
      this.loading = true;
      console.log('toggling interview');
      console.log(applicant);
      const method = applicant.isInterview ? 'delete' : 'put';
      ApiService[method](Api.endpoints.INTERVIEW(applicant._id))
        .then(({ data }) => {
          this.mutateSentListAfterInterview(data.data);
        })
        .catch((error) => console.log(error))
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.user-response {
  display: inline-block;
  width: 130px;
  height: 32px;
  border-radius: 3px;
  background: transparent;
  color: #3c3c3c;
  padding: 5px;
  text-align: center;
  max-height: 32px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.status-badge {
  display: inline-block;
  padding: 10px 24px;
  border-radius: 4px;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
  min-width: 150px;
  max-height: 40px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.green-tab {
  background-color: #5bb55b;
}

td {
  text-align: center !important;
  color: #3c3c3c !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}

tr {
  cursor: pointer;
}

.interview-container {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
}

.interview-text {
  font-size: 12px;
  color: #787878;
  font-weight: 400;
  line-height: 1.2;
  text-align: left;
}
</style>
